var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tailwind Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0004 17.6004C11.0004 16.3854 11.9854 15.4004 13.2004 15.4004H15.4004V13.2004C15.4004 11.9854 16.3854 11.0004 17.6004 11.0004C18.8154 11.0004 19.8004 11.9854 19.8004 13.2004V15.4004H22.0004C23.2154 15.4004 24.2004 16.3854 24.2004 17.6004C24.2004 18.8154 23.2154 19.8004 22.0004 19.8004H19.8004V22.0004C19.8004 23.2154 18.8154 24.2004 17.6004 24.2004C16.3854 24.2004 15.4004 23.2154 15.4004 22.0004V19.8004H13.2004C11.9854 19.8004 11.0004 18.8154 11.0004 17.6004Z",
    fill: "#310048"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40039 17.6004C4.40039 10.3102 10.3102 4.40039 17.6004 4.40039C24.8905 4.40039 30.8004 10.3102 30.8004 17.6004C30.8004 20.4512 29.8967 23.091 28.36 25.2488L38.956 35.8448C39.8152 36.7039 39.8152 38.0969 38.956 38.956C38.0969 39.8152 36.7039 39.8152 35.8448 38.956L25.2488 28.36C23.091 29.8967 20.4512 30.8004 17.6004 30.8004C10.3102 30.8004 4.40039 24.8905 4.40039 17.6004ZM17.6004 8.80039C12.7403 8.80039 8.80039 12.7403 8.80039 17.6004C8.80039 22.4605 12.7403 26.4004 17.6004 26.4004C22.4605 26.4004 26.4004 22.4605 26.4004 17.6004C26.4004 12.7403 22.4605 8.80039 17.6004 8.80039Z",
    fill: "#310048"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomingIcon);
export default __webpack_public_path__ + "static/media/zooming-icon.b334f403bc7d5885dcca297394f38349.svg";
export { ForwardRef as ReactComponent };